export default function TableUnderMapNoObjectType() {
    return (
        <div className="table-under-map-no-object-type">
            Нет доступных объектов
        </div>
    )
}
